module.exports = __webpack_public_path__ + "static/media/googlebooks.b446c2aa.png";